<!-- svelte-ignore a11y-no-static-element-interactions -->
<!-- svelte-ignore a11y-click-events-have-key-events -->
<script lang="ts">
  import Play from './play.svelte'
  import {
    ordinalNumber,
    type GameraTeamReference,
    type GoalEvent,
  } from '@statmuse/core/gamera'
  import { plays, lineScore, periodClock } from './stores'
  import { first, max, range, round } from 'lodash-es'
  import HockeyRink from './hockey-rink.svelte'
  import ScoringPlaySummary from './scoring-play-summary.svelte'

  export let awayTeam: GameraTeamReference | undefined
  export let homeTeam: GameraTeamReference | undefined
  export let live = false
  export let includeScoringPlays = false

  let selectedTab = live
    ? $periodClock.period ?? 0
    : includeScoringPlays
    ? -1
    : 0

  $: firstPlayOfCurrentPeriod = first(
    $plays.filter((p) => p.period === $periodClock.period),
  )

  $: hasShootout = firstPlayOfCurrentPeriod?.clock === '00:00'

  $: selectorWidth = round(
    (1 /
      (max([3, $lineScore.away?.periods?.length]) +
        (hasShootout ? 2 : 1) +
        (includeScoringPlays ? 1 : 0))) *
      100,
    1,
  )

  $: tabs = [
    ...(includeScoringPlays ? [{ label: 'Goals', value: -1 }] : []),
    { label: 'All', value: 0 },
    ...range(1, (max([3, $lineScore.away?.periods?.length]) ?? 3) + 1).map(
      (x) => ({
        label: `${x < 4 ? ordinalNumber(x) : x === 4 ? '' : x - 3}${
          x > 3 ? 'OT' : ''
        }`,
        value: x,
      }),
    ),
    ...(hasShootout
      ? [{ label: 'SO', value: $lineScore.away?.periods?.length + 1 }]
      : []),
  ]

  $: events =
    selectedTab === 0
      ? $plays.filter((p) => p.type !== 'substitution')
      : selectedTab === -1
      ? $plays.filter(
          (p): p is GoalEvent =>
            p.type === 'goal' &&
            p.period <= max([3, $lineScore.away?.periods?.length]),
        )
      : $plays
          .filter((p) => p.period === selectedTab)
          .filter((p) => p.type !== 'substitution')

  $: {
    if (live) {
      events = [...events].reverse()
    }
  }

  $: goalEvents = events.filter((e) => e.type === 'goal')
  $: shotEvents = events.filter(
    (e) => e.type === 'shotSaved' || e.type === 'shotMissed',
  )
  $: penaltyEvents = events.filter((e) => e.type === 'penalty')
  $: hitEvents = events.filter((e) => e.type === 'hit')
</script>

<div
  class="md:max-w-96 w-full mx-auto relative flex justify-between bg-gray-8 dark:bg-gray-3 rounded-full border border-gray-6 dark:border-gray-3"
>
  <span
    class="absolute h-full bg-teal dark:bg-gray-7 rounded-full transition-transform ease-out"
    style:width={selectorWidth + '%'}
    style:left={(selectedTab + (includeScoringPlays ? 1 : 0)) * selectorWidth +
      '%'}
  />
  {#each tabs as tab (tab)}
    <div
      class="flex-1 py-1 text-center relative cursor-pointer"
      class:dark:text-gray-2={selectedTab === tab.value}
      class:text-gray-8={selectedTab === tab.value}
      on:click={() => (selectedTab = tab.value)}
    >
      {tab.label}
    </div>
  {/each}
</div>

<HockeyRink
  {awayTeam}
  {homeTeam}
  {goalEvents}
  {shotEvents}
  {penaltyEvents}
  {hitEvents}
  period={selectedTab !== 0 && selectedTab > 0
    ? tabs[selectedTab + (includeScoringPlays ? 1 : 0)].label
    : undefined}
/>

{#if includeScoringPlays && selectedTab === -1}
  <ScoringPlaySummary {awayTeam} {homeTeam} {live} />
{:else}
  {#each events as event (event.eventSequence)}
    <Play play={event} {awayTeam} {homeTeam} />
  {/each}
{/if}
